module.exports = __webpack_public_path__ + "img/fireSYJ.f1224058.png";